import UpdateForm from "../components/noticeUpdate/UpdateForm";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
通知マスタ一覧
 */
const Notice = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <UpdateForm></UpdateForm>
    </SpaceBetween>
  );
};

export default Notice;
